export const environment = {
  production: false,
  theme: 'cbi',
  graphql_endpoint: 'https://hasura.app.checkimpresa.it/v1/graphql',
  ws_graphql: 'wss://hasura.app.checkimpresa.it/v1/graphql',
  admin_endpoint: 'https://admin.app.checkimpresa.it/',
  logo: 'logo-checkimpresa.png',
  favicon: 'favicon.png',
  title: "Check Impresa",
  auth: {
    domain: "cbi-it.eu.auth0.com",
    clientId: "z6Y7KhhgPnbkV0tsHbkfH0MqjSEj7oQ2",
    audience: 'CBI-API', // <-- will come back to this
    redirectUrl: window.location.origin,
    httpInterceptor: {
      allowedList: [
        // Attach access tokens to any calls that start with '/api/'
        'https://api.app.checkimpresa.it/api/*',
        'https://app.checkimpresa.it/*',
        'https://hasura.app.checkimpresa.it/*',
        '/api/*',
      ],
    }
  }
};
